import font from '@translated/babele-tokens/assets/arsmaquettepro.css?url'
import stylesheet from '~/tailwind.css?url'
import type {LinksFunction} from 'react-router'

export const ROOT_LINKS: ReturnType<LinksFunction> = [
  {rel: 'stylesheet', href: stylesheet},
  {rel: 'stylesheet', href: font},
  {rel: 'preload', href: font, as: 'style'},
  {
    rel: 'preload',
    href: '/fonts/noto-sans/NotoSans-Regular.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous'
  },
  {
    rel: 'preload',
    href: '/fonts/noto-sans/NotoSans-Medium.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous'
  },
  {
    rel: 'preload',
    href: '/fonts/noto-sans/NotoSans-Bold.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous'
  },
  {rel: 'dns-prefetch', href: 'https://region1.google-analytics.com'},
  {rel: 'preconnect', href: 'https://region1.google-analytics.com'},
  {rel: 'dns-prefetch', href: 'https://www.googletagmanager.com'},
  {rel: 'preconnect', href: 'https://www.googletagmanager.com'},
  {rel: 'dns-prefetch', href: 'https://consentcdn.cookiebot.com'},
  {rel: 'preconnect', href: 'https://consentcdn.cookiebot.com'},
  {rel: 'dns-prefetch', href: 'https://consent.cookiebot.com'},
  {rel: 'preconnect', href: 'https://consent.cookiebot.com'}
]
